import { useMantineColorScheme } from '@mantine/core';
import { useEffect, useState } from 'react';

interface LogoProps {
  height?: number | string;
  width?: number | string;
  className?: string;
}

export function Logo({ height = 40, width = 'auto', className }: LogoProps) {
  const { colorScheme } = useMantineColorScheme();
  const [isDark, setIsDark] = useState(false);

  useEffect(() => {
    // Check if Mantine color scheme is set, otherwise check system preference
    if (colorScheme === 'dark' || colorScheme === 'auto') {
      if (colorScheme === 'auto') {
        const prefersDark = window.matchMedia('(prefers-color-scheme: light)').matches;
        setIsDark(prefersDark);
      } else {
        setIsDark(true);
      }
    } else {
      setIsDark(false);
    }
  }, [colorScheme]);

  const logoSrc = isDark ? '/logo_dark.svg' : '/logo_light.svg';
  
  return (
    <img 
      src={logoSrc} 
      alt="HMH Procurement Logo" 
      height={height}
      width={width}
      className={className}
      style={{ height, width }}
    />
  );
}

